(function () {
  var GSAP_SRC = "https://cdn.jsdelivr.net/npm/gsap@3.15.0/dist/gsap.min.js";
  var SCROLL_SRC = "https://cdn.jsdelivr.net/npm/gsap@3.15.0/dist/ScrollTrigger.min.js";

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.getAttribute("data-loaded") === "true" || (src.indexOf("gsap.min") !== -1 && window.gsap) || (src.indexOf("ScrollTrigger") !== -1 && window.ScrollTrigger)) {
          resolve();
          return;
        }
        existing.addEventListener("load", function () { resolve(); }, { once: true });
        existing.addEventListener("error", reject, { once: true });
        return;
      }
      var script = document.createElement("script");
      script.src = src;
      script.async = false;
      script.onload = function () {
        script.setAttribute("data-loaded", "true");
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function whenGsap() {
    if (window.gsap && window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
      return Promise.resolve();
    }
    if (!window.__mwgGsapPromise) {
      window.__mwgGsapPromise = loadScript(GSAP_SRC)
        .then(function () { return loadScript(SCROLL_SRC); })
        .then(function () { window.gsap.registerPlugin(window.ScrollTrigger); });
    }
    return window.__mwgGsapPromise;
  }

  function destroy(root) {
    if (root._gyDestroy) root._gyDestroy();
    delete root.dataset.gyReady;
  }

  function init(root) {
    if (root.dataset.gyReady === "true") return;
    root.dataset.gyReady = "true";

    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var guide = root.querySelector("[data-gy-guide]");
    var facts = root.querySelector("[data-gy-facts]");
    var button = root.querySelector("[data-gy-toggle]");
    var photo = root.querySelector(".gy-intro__photo img");
    var tweens = [];

    function onClick() {
      var open = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", open ? "false" : "true");
      if (!guide) return;
      if (reduce || !window.gsap) {
        guide.style.height = open ? "0px" : "auto";
        if (facts) facts.style.display = open ? "" : "none";
        return;
      }
      if (open) {
        tweens.push(gsap.to(guide, { height: 0, duration: 0.45, ease: "power2.inOut" }));
        if (facts) {
          facts.style.display = "";
          tweens.push(gsap.fromTo(facts, { height: 0, autoAlpha: 0 }, {
            height: "auto",
            autoAlpha: 1,
            duration: 0.45,
            ease: "power2.out",
            onComplete: function () { if (window.ScrollTrigger) ScrollTrigger.refresh(); }
          }));
        }
      } else {
        if (facts) tweens.push(gsap.to(facts, { height: 0, autoAlpha: 0, duration: 0.35, ease: "power2.inOut" }));
        tweens.push(gsap.to(guide, {
          height: "auto",
          duration: 0.55,
          ease: "power2.out",
          onComplete: function () { if (window.ScrollTrigger) ScrollTrigger.refresh(); }
        }));
      }
    }

    if (button) button.addEventListener("click", onClick);

    if (!reduce && window.gsap) {
      if (photo) {
        tweens.push(gsap.fromTo(photo, { scale: 1.06 }, { scale: 1, duration: 1.4, ease: "power2.out" }));
        tweens.push(gsap.to(photo, {
          y: 28,
          ease: "none",
          scrollTrigger: {
            trigger: root.querySelector(".gy-intro__top"),
            start: "top top",
            end: "bottom top",
            scrub: true
          }
        }));
      }
      tweens.push(gsap.from(root.querySelectorAll(".gy-intro__copy > *:not([data-gy-toggle])"), {
        y: 16,
        autoAlpha: 0,
        duration: 0.8,
        ease: "power2.out",
        stagger: 0.08,
        delay: 0.15,
        clearProps: "opacity,visibility"
      }));
      if (facts) {
        tweens.push(gsap.from(facts.children, {
          y: 10,
          autoAlpha: 0,
          duration: 0.7,
          ease: "power2.out",
          stagger: 0.06,
          delay: 0.45
        }));
      }
    }

    root._gyDestroy = function () {
      if (button) button.removeEventListener("click", onClick);
      if (window.gsap) {
        tweens.forEach(function (tween) {
          if (tween && tween.scrollTrigger) tween.scrollTrigger.kill();
          if (tween && tween.kill) tween.kill();
        });
      }
    };
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll("[data-gy-intro]");
    if (!nodes.length) return;
    whenGsap().then(function () {
      nodes.forEach(init);
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    }).catch(function () {
      nodes.forEach(init);
    });
  }

  boot(document);

  if (!window.__gyIntroEvents) {
    window.__gyIntroEvents = true;
    document.addEventListener("shopify:section:load", function (event) {
      boot(event.target);
    });
    document.addEventListener("shopify:section:unload", function (event) {
      var root = event.target.querySelector("[data-gy-intro]");
      if (root) destroy(root);
    });
  }
})();
